import logo from "./logo.svg";
import "./App.css";
import Navbar from "./Components/Navbar";
import MainPage from "./Components/MainPage";
import Footer from "./Components/Footer";

function App() {
    return (
        <>
            <Navbar />
            <MainPage />
            <Footer />
        </>
    );
}

export default App;
